import { FONT_BASE } from '../../constants/AppFonts';

export class PriceTag extends Phaser.GameObjects.Container {
  constructor(scene, price) {
    super(scene);
    scene.add.existing(this);
    const panel = scene.add.image(0, 0, 'graphics', 'price_display');
    this._label = scene.add
      .text(panel.width * 0.5 - 10, 0, price || 0, {
        fontFamily: FONT_BASE.REGULAR,
        fontSize: 28,
        align: 'right',
        color: '#FFFFFF',
      })
      .setOrigin(1, 0.5);
    this.add([panel, this._label]);
  }

  destroy() {
    super.destroy();
  }
}
